import type { RangeWidgetConfig } from './types'

/**
 * Returns the default configuration for range (value range with labels) widgets.
 *
 * @returns Default range widget config.
 */
export function rangeConfig(): RangeWidgetConfig {
  return {}
}
